<div class="container" id="contact">

  <div>
    <h1 class="text-center">Kontakt</h1>
  </div>

  <div class="form">
    <!--TODO Form Validation-->
    <form role="form" class="php-email-form" [formGroup]="contactForm" (ngSubmit)="this.onSubmit()">
      <div class="row">
        <div class="form-group col-md-6">
          <input type="text" name="name" class="form-control" id="name"
                 placeholder="Name*" formControlName="name" required
                 [class.is-invalid]="(this.getFormControls()['name'].touched || this.getFormControls()['name'].dirty) && this.getFormControls()['name'].invalid">
          <div *ngIf="this.getFormControls()['name'].touched && this.getFormControls()['name'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['name'].errors?.['required']">Ihr Name ist erforderlich.</div>
            <div *ngIf="this.getFormControls()['name'].errors?.['pattern']">Ihr Name enthält ein ungültiges Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['name'].errors?.['minlength']">Der eingegebene Name ist zu kurz</div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="email" class="form-control" name="email" id="email" placeholder="E-Mail*" formControlName="email" required
                 [class.is-invalid]="(this.getFormControls()['email'].touched || this.getFormControls()['email'].dirty) && this.getFormControls()['email'].invalid">
          <div *ngIf="this.getFormControls()['email'].touched && this.getFormControls()['email'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['email'].errors?.['required']">Ihre E-Mail Adresse ist erforderlich.
            </div>
            <div *ngIf="this.getFormControls()['email'].errors?.['email']">Die eingegebene E-Mail Adresse ist leider
              nicht gültig.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group col-md-6">
        <input type="tel" class="form-control" name="phone" id="phone"
               placeholder="Telefonnummer" formControlName="phone"
               [class.is-invalid]="(this.getFormControls()['phone'].touched || this.getFormControls()['phone'].dirty) && this.getFormControls()['phone'].invalid">
        <div *ngIf="this.getFormControls()['phone'].touched && this.getFormControls()['phone'].invalid"
             class="alert alert-danger">
          <div *ngIf="this.getFormControls()['phone'].errors?.['minlength']">Die eingegebene Rufnummer ist zu kurz</div>
        </div>
      </div>
      <div class="form-group">
        <input type="text" class="form-control" name="subject" id="subject"
               placeholder="Betreff*"
               formControlName="subject" required
               [class.is-invalid]="(this.getFormControls()['subject'].touched || this.getFormControls()['subject'].dirty) && this.getFormControls()['subject'].invalid">
        <div *ngIf="(this.getFormControls()['subject'].touched || this.getFormControls()['subject'].dirty) && this.getFormControls()['subject'].invalid"
             class="alert alert-danger">
          <div *ngIf="this.getFormControls()['subject'].errors?.['minlength']">Der eingegebene Betreff ist leider zu kurz</div>
           <div *ngIf="this.getFormControls()['subject'].errors?.['required']">Der Betreff Ihrer Anfrage ist leider erforderlich</div>
        </div>
      </div>
      <div class="form-group">
        <textarea class="form-control" name="message" rows="5" placeholder="Nachricht*" formControlName="message"
                  required  [class.is-invalid]="(this.getFormControls()['message'].touched || this.getFormControls()['message'].dirty) && this.getFormControls()['message'].invalid"></textarea>
        <div *ngIf="this.getFormControls()['message'].touched && this.getFormControls()['message'].invalid"
             class="alert alert-danger">
          <div *ngIf="this.getFormControls()['message'].errors?.['minlength']">Die eingegebene Nachricht ist leider zu kurz</div>
          <div *ngIf="this.getFormControls()['message'].errors?.['required']">Ihre Nachricht ist leider erforderlich</div>
        </div>

      </div>
      <div class="my-3">
        <div *ngIf="this.sentstatus === 1" class="sent-message">Ihre Nachricht wurde gesendet. Dankeschön!</div>
        <div *ngIf="this.sentstatus === 2" class="error-message">Ihre Nachricht konnte leider nicht übermittelt werden</div>
        <div *ngIf="this.sentstatus === 3" class="error-message">Sie haben zu viele Anfragen gestellt, bitte versuchen Sie es später nochmal</div>
      </div>
      <div class="text-center" id="senddiv">
        <button id="senden" disabled class="nocursor" type="submit">Absenden</button>
      </div>
      <br><small>Die mit diesem Kontaktformular übermittelten Daten werden einschließlich Ihrer Kontaktdaten
      gespeichert, um Ihre Anfrage bearbeiten zu können oder um für Anschlussfragen bereitzustehen. Eine Weitergabe
      dieser Daten findet grundsätzlich nicht statt.</small><br>
    </form>
  </div>


  <div class="row contact-info">

    <div class="col-md-4">
      <div class="contact-address">
        <i class="bi bi-geo-alt"></i>
        <h3>Adresse</h3>
        <span>Autenbachstr. 12-16</span>
        <p>71711 Steinheim / Deutschland</p>
      </div>
    </div>

    <div class="col-md-4">
      <div class="contact-phone">
        <i class="bi bi-telephone"></i>
        <h3>Telefon</h3>
        <p><a id="contact_telefon" href="tel:+49714489723-29">+49 7144 89723-29</a></p>
      </div>
    </div>

    <div class="col-md-4">
      <div class="contact-email">
        <i class="bi bi-envelope"></i>
        <h3>E-Mail</h3>
        <p><a id="contact_mail" href="mailto:info@i-logistix.de">info&commat;i-logistix.de</a></p>
      </div>
    </div>
  </div>
</div>
